import { render, staticRenderFns } from "./weixinDict.vue?vue&type=template&id=26874300&"
import script from "./weixinDict.vue?vue&type=script&lang=js&"
export * from "./weixinDict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports